<template>

    <v-autocomplete
      v-model="localSelectedID"
      :items="items"
      :search-input.sync="search"
      hide-no-data
      hide-details
      item-text="name"
      item-value="id"
      placeholder="Search..."
      solo
    ></v-autocomplete>
</template>

<script>
  export default {
    props: {
      selectedID: null
    },
    data: () => ({
      search: '',
      items: [],
      isLoading: false
    }),
    computed: {
      localSelectedID: {
        get () {
          return this.selectedID
        },
        set (nv) {
          this.$emit('update:selectedID', nv)
          this.$emit('change', this.items.find(item => item.id === nv))
        }
      }
    },
    watch: {
      search (val) {
        this.fetchAPI()
      }
    },
    methods: {
      fetchAPI () {
        var filters = {
          search: this.search,
          selectedID: this.selectedID
        }
        const encodedFilters = btoa(JSON.stringify(filters))
        this.isLoading = true
        this.$axios.get('/inventory-tx/categories/autocomplete?filters=' + encodedFilters)
          .then(response => {
            var rows = response.data.rows
            this.count = response.data.count
            this.items = rows //.filter(item => item.complete === 0)
          })
          .catch(error => console.log(error))
          .then(() => this.isLoading = false)
      }
    }
  }
</script>